var normalizeComponent = require("!../../node_modules/vue-loader/lib/component-normalizer")
/* script */
import __vue_script__ from "!!babel-loader?{\"cacheDirectory\":true,\"babelrc\":false,\"presets\":[[\"/opt/build/repo/node_modules/babel-preset-poi/index.js\",{\"jsx\":\"vue\"}]]}!../../node_modules/vue-loader/lib/selector?type=script&index=0!./Create.vue"
/* template */
import __vue_template__ from "!!../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-39f67d0a\",\"hasScoped\":false}!../../node_modules/vue-loader/lib/selector?type=template&index=0!./Create.vue"
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Create.vue
// module id = 97
// module chunks = 1